import React, { useCallback, useEffect } from 'react'
import {TagIcon} from '@heroicons/react/outline'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { contentInput, contentMessage } from '../../recoil/content';
import { topicData, topicLoading } from '../../recoil/topic';
import { domainWeb } from '../../config/constants';
import axios from 'axios';
import { authenticated } from '../../recoil/auth';

const TopicInput = () => {
  const auth = useRecoilValue(authenticated);
  const [input, setInput] = useRecoilState(contentInput);
  const [loading, setLoading] = useRecoilState(topicLoading);
  const [topics, setTopics] = useRecoilState(topicData);
  const setMessage = useSetRecoilState(contentMessage);

  const changeTopic = (topic) => {
    let newInput = {...input};
    newInput.topic = topic;
    setInput(newInput);
  }

  const getTopicsData = useCallback(async () => {
    setLoading(true);
    setMessage({});
    try {
      let url = `${domainWeb}/topics`;
      let response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json', 
          'Accept': 'application/json', 
          'Authorization': 'Bearer ' + auth.token
        }
      });
      setTopics(response.data);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setMessage({
        success: false,
        text: error,
      });
      setLoading(false);
    }
  }, [auth.token, setLoading, setMessage, setTopics]);

  const loadData = () => {
    return (
      <select onChange={e => changeTopic(e.target.value)} value={input.topic} name="topic" id="topic" className="w-full p-0 bg-transparent border-none focus:ring-0">
          <option value="">{loading? "Tunggu..." : "Pilih Topik"}</option>
          {
            topics.map((item, i) => (
              <option key={i} value={item.id}>{item.title}</option>
            ))
          }
      </select>
    );
  };

  useEffect(() => {
    getTopicsData();
  }, [getTopicsData]);

  return (
    <div className="flex flex-col items-start">
        <label htmlFor="topic" className="text-sm">Topik <span className="text-xs text-red-500">{"(wajib diisi)"}</span></label>
        <div className="flex items-center w-full gap-5 px-5 py-3 mt-2 rounded-lg bg-slate-50">
            <TagIcon className="w-6 h-6" />
            {loadData()}
        </div>
    </div>
  )
}

export default TopicInput